import ConnectionsDirectory from '@/components/Settings/ConnectionsDirectory'
import PendingApprovalsPanel from '@/components/Settings/PendingApprovalsPanel'
import LlmProviderConnections from '@/components/Settings/LlmProviderConnections'
import SettingsKpiCards from '@/components/Settings/SettingsKpiCards'
import { CONNECTIONS_KPI } from '@/components/Settings/settingsKpiPlaceholders'
import { getSettingsSectionIntro } from '@/components/Settings/settingsSectionDescriptions'
import { featureFlags } from '@/config/featureFlags'

export default function SettingsConnectionsSection() {
  return (
    <>
      {/* Above the metrics on purpose: a waiting action is the only thing on
          this page that is blocked on the user. */}
      <PendingApprovalsPanel />
      {!featureFlags.connectionsPageV2 ? (
        <SettingsKpiCards
          sectionTitle="Connection metrics"
          intro={getSettingsSectionIntro('connections-metrics')}
          items={CONNECTIONS_KPI}
        />
      ) : null}
      <ConnectionsDirectory />
      <LlmProviderConnections />
    </>
  )
}
